/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React, { useState, useEffect } from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'

import { NetworkContentConfiguration } from '@professocial/professocialTypes/types'

// NetworkContent
import ProfessocialNetworkContent from '@professocial/professocialNetworkContent/src/screens/ProfessocialNetworkContent'
import { networkContentRootReducer } from '@professocial/professocialNetworkContent/src/store/networkContentRoot.reducer'
import { networkContentRootSagas } from '@professocial/professocialNetworkContent/src/store/networkContentRoot.sagas'

interface IImportProfessocialNetworkContentProps {
  networkContentConfiguration?: NetworkContentConfiguration
}
// NetworkContent
const sagaMiddleware = createSagaMiddleware()
const storeNetworkContent = createStore(
  networkContentRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)
sagaMiddleware.run(networkContentRootSagas)

const ImportProfessocialNetworkContent: React.FC<IImportProfessocialNetworkContentProps> = (props) => {
  const [networkContentConfiguration, setNetworkContentConfiguration] = useState<NetworkContentConfiguration>()

  useEffect(() => {
    setNetworkContentConfiguration(props.networkContentConfiguration)
  }, [props.networkContentConfiguration],
  )

  return (
    <Provider store={storeNetworkContent}>
      <ProfessocialNetworkContent networkContentConfiguration={networkContentConfiguration} />
    </Provider>
  )
}
export default ImportProfessocialNetworkContent
